// ------------------------------------------
// ページ読み込み後に実行される処理（Waypoints & スクロール制御）
// ------------------------------------------
$(function () {
  // ナビリンク要素を取得
  const $links = $('[data-linkto]');
  const sections = []; // セクションIDリスト
  const links = {};    // セクションID → リンク要素対応表

  // 各リンクに対応するセクションIDを収集
  $links.each(function () {
    const id = $(this).data('linkto');
    sections.push(`#${id}`);
    links[id] = $(this);
  });
  // Waypointでセクション表示位置に応じてナビを更新
  sections.forEach(function (selector, index) {
    const sectionId = selector.replace("#", "");

    $(selector).waypoint(function (direction) {
      if (direction === "down") {
        setCurrentLink(sectionId);
      } else {
        const prevId = sections[Math.max(index - 1, 0)].replace("#", "");
        setCurrentLink(prevId);
      }
    }, { offset: "30%" }); // 画面の30%で切り替え
  });

  // 現在のリンク表示を更新する関数
  function setCurrentLink(id) {
    $(".js-pagelink").removeClass("is-current is-near");

    const $currentLink = links[id];
    $currentLink?.addClass("is-current");

    const $items = $(".history__contents-nav-item");
    const currentIndex = $items.index($currentLink.closest("li"));

    // 現在位置の前後に "is-near" クラスを付加
    [-1, 1].forEach((offset) => {
      const targetIndex = currentIndex + offset;
      if (targetIndex >= 0 && targetIndex < $items.length) {
        const $targetLink = $items.eq(targetIndex).find("a");
        if (!$targetLink.hasClass("is-current")) {
          $targetLink.addClass("is-near");
        }
      }
    });

    const $scrollList = $('#scroll-list');

    // スマホとPCでスクロール処理を分岐
    if (window.innerWidth <= 749) {
      // 横スクロールで中央配置（スマホ）
      const itemWidth = $currentLink.closest('li').outerWidth(true);
      const listWidth = $scrollList.outerWidth();
      const newScrollLeft = itemWidth * currentIndex - (listWidth / 2) + (itemWidth / 2);
      $scrollList.stop().animate({ scrollLeft: newScrollLeft }, 200);
    } else {
      // 縦スクロールで中央配置（PC）
      const itemHeight = $currentLink.closest("li").outerHeight();
      const newScrollTop = itemHeight * (currentIndex - 2);
      $scrollList.stop().animate({ scrollTop: newScrollTop }, 200);
    }
  }

  // ページ読み込み時にトップへスクロール（UX向上用）
  $(window).on("load", function () {
    $("html, body").animate({ scrollTop: 0 }, 10);
  });

// ▼ PC・スマホ共通のスクロールボタン制御 ▼
const $scrollList = $('#scroll-list');
let scrollAnimationFrame;
let scrollSpeed = 0;
let isScrolling = false;

// スクロール開始 (PCのマウスホバー用)
function startScroll(direction) {
  // PCの場合のみ実行
  if (window.innerWidth > 750) {
    $scrollList.closest('.history-nav-wrapper').addClass('hovering');
    isScrolling = true;

    scrollSpeed = direction === 'up' ? -2 : 2;

    function step() {
      if (!isScrolling) return;
      $scrollList.scrollTop($scrollList.scrollTop() + scrollSpeed);
      scrollAnimationFrame = requestAnimationFrame(step);
    }
    scrollAnimationFrame = requestAnimationFrame(step);
  }
}

// スクロール停止 (PCのマウスホバー用)
function stopScroll() {
  if (window.innerWidth > 750) {
    isScrolling = false;
    cancelAnimationFrame(scrollAnimationFrame);
    $scrollList.closest('.history-nav-wrapper').removeClass('hovering');
  }
}

// PC用イベント（マウスホバー）
$('#scroll-up').on('mouseenter', () => startScroll('up'));
$('#scroll-up').on('mouseleave', stopScroll);
$('#scroll-down').on('mouseenter', () => startScroll('down'));
$('#scroll-down').on('mouseleave', stopScroll);

// スマホ用イベント（タッチ）
// 1回のタッチでリストが1つ動くように設定
$('#scroll-up').on('touchstart', (e) => {
  if (window.innerWidth <= 749) {
    e.preventDefault();
    const scrollAmount = 100; // 調整してください
    $scrollList.scrollLeft($scrollList.scrollLeft() - scrollAmount);
  }
});

$('#scroll-down').on('touchstart', (e) => {
  if (window.innerWidth <= 749) {
    e.preventDefault();
    const scrollAmount = 100; // 調整してください
    $scrollList.scrollLeft($scrollList.scrollLeft() + scrollAmount);
  }
});

// ナビ hover 時のアクティブ表示切替
$('.history-nav-wrapper').hover(
  () => $('#scroll-list').addClass('active'),
  () => $('#scroll-list').removeClass('active')
);
});

// ------------------------------------------
// スクロール位置に応じて history-nav-wrapper を表示／非表示に切り替える制御
// ------------------------------------------
$(function () {
  const $navWrapper = $('.history-nav-wrapper');
  const $content = $('.history__chart-content');
  let navVisible = false; // 現在の表示状態を記録

  // ★ ナビ表示切り替え関数（スクロール監視用）
  function updateNavVisibility() {
    const contentTop = $content.offset().top;
    const contentBottom = contentTop + $content.outerHeight();
    const windowTop = $(window).scrollTop();
    const windowBottom = windowTop + $(window).height();
    const threshold = 200; // 余裕をもって表示切り替えするマージン

    if (windowTop < contentTop - threshold || windowBottom >= contentBottom) {
      if (navVisible) {
        $navWrapper.css({
          visibility: 'hidden',
          opacity: 0,
          transition: 'opacity 0.5s ease'
        });
        navVisible = false;
      }
    } else {
      if (!navVisible) {
        $navWrapper.css({
          visibility: 'visible',
          opacity: 1,
          transition: 'opacity 0.5s ease'
        });
        navVisible = true;
      }
    }
  }

  // 初期状態で非表示にしておく（スマホのチラ見え防止）
  $navWrapper.css({
    visibility: 'hidden',
    opacity: 0
  });

  // スクロールのたびに表示判定
  $(window).on('scroll', updateNavVisibility);

  // ページ読み込み時にも初回判定を実行
  $(window).on('load', function () {
    $("html, body").animate({ scrollTop: 0 }, 10);
    updateNavVisibility();
  });
});
